module.exports = __webpack_public_path__ + "img/img_main_product_03.9309ef7f.jpg";